import { UseTranscriptItemReturn } from "./Transcription.hooks.decl";

import { SPEAKERS_COLORS } from "@/constants/style.constants";
import { useCall } from "@/hooks/useCall/useCall";

const DEFAULT_STYLE: UseTranscriptItemReturn = {
  color: "warning-500",
  shouldRenderAvatar: false,
};

export const useTranscriptItemStyle = (
  channel: number
): UseTranscriptItemReturn => {
  const { call } = useCall();

  if (call?.type === "voicemail" || !call?.speakers) {
    return DEFAULT_STYLE;
  }

  const speaker = call.speakers.get?.(channel);

  if (!speaker) {
    return DEFAULT_STYLE;
  }
  const { variant } = speaker;

  return {
    color: SPEAKERS_COLORS[variant] ?? DEFAULT_STYLE.color,
    shouldRenderAvatar: true,
  };
};
